import React, {useState, useEffect, useRef} from 'react';
import TeamShortTermGoal from './TeamShortTermGoal.mjs';
import TeamShortTermGoalDefaultMessage from './TeamShortTermGoalDefaultMessage.mjs';
import TeamShortTermGoalAddForm from './TeamShortTermGoalAddForm.mjs';
import TeamShortTermGoalsList from './TeamShortTermGoalsList.mjs';
import TeamShortTermGoalsInformation from './TeamShortTermGoalsInformation.mjs';
import TeamAssignedActionItemList from './TeamAssignedActionItemList.mjs';
import './Card.css';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function TeamShortTermGoalsCard({team_id}) 
{
    const { team, short_term_goal, setShortTermGoal, team_short_term_goals } = useCTAL();

    const [stg_display, setSTGDisplay] = useState(<> </>);
    
    const [img_loc] = useState('./images/'); 
    const [img_ext] = useState('.svg'); 
    const [img_sel] = useState('-sel'); 

    const [img_stg]       = useState('stg'); 
    const [img_add_stg]   = useState('add'); 
    const [img_sel_stg]   = useState('select'); 
    const [img_info_stg]  = useState('info'); 
    
    const [img_stg_file,      setImgSTGFile]     = useState(img_loc + img_stg      + img_sel + img_ext); 
    const [img_add_stg_file,  setImgAddSTGFile]  = useState(img_loc + img_add_stg  + img_ext); 
    const [img_sel_stg_file,  setImgSelSTGFile]  = useState(img_loc + img_sel_stg  + img_ext); 
    const [img_info_stg_file, setImgInfoSTGFile] = useState(img_loc + img_info_stg + img_ext); 

    const [current_display_type, setCurrentDisplayType] = useState("stg"); 

    const tooltipRef_stg  = useRef(null);
    const tooltipRef_add  = useRef(null);
    const tooltipRef_sel  = useRef(null);
    const tooltipRef_info = useRef(null);
    
    useEffect(() => {
        const tooltip_stg  = new window.bootstrap.Tooltip(tooltipRef_stg.current,  { container: 'body', trigger: 'hover' });
        const tooltip_add  = new window.bootstrap.Tooltip(tooltipRef_add.current,  { container: 'body', trigger: 'hover' });
        const tooltip_sel  = new window.bootstrap.Tooltip(tooltipRef_sel.current,  { container: 'body', trigger: 'hover' });
        const tooltip_info = new window.bootstrap.Tooltip(tooltipRef_info.current, { container: 'body', trigger: 'hover' });
  
        return () => {
            tooltip_stg.dispose();
            tooltip_add.dispose();
            tooltip_sel.dispose();
            tooltip_info.dispose();
        };
    }, []);

    useEffect(() =>
    {
        if (!team) return;

        if (DEBUG) console.log(`TeamShortTermGoalsCard - Team: ${team.TeamName} NumShortTermGoals: ${team.NumShortTermGoals}`)

        if (!team_short_term_goals || (team_short_term_goals.length <= 0)) return;

        if (!short_term_goal)
            setShortTermGoal(team_short_term_goals[0]); //Default to most recent Goal
        else {
            var stg_found = false;
            for (var i=0; ((i < team_short_term_goals.length) && (!stg_found)); i++) {
                if (short_term_goal.ShortTermGoalID == team_short_term_goals[i].ShortTermGoalID) {
                    stg_found = true;
                    setShortTermGoal(team_short_term_goals[i]); //set to previously selected Goal
                }
            }
        }
    }, [team]);

    useEffect(() =>
    {
        if ((!short_term_goal) && (team.NumShortTermGoals <= 0)) { change_display("stg-default", true); return; }
        change_display("stg", true)
    }, [short_term_goal]);

    const display_sel_stg = (sel_stg) => {
        setShortTermGoal(sel_stg);
    }

    const change_display = (display_type, reset=false) => {
        if ((display_type == current_display_type) && (!reset)) return; //No Change
      
        setImgSTGFile(    img_loc + img_stg      + img_ext); 
        setImgAddSTGFile( img_loc + img_add_stg  + img_ext); 
        setImgSelSTGFile( img_loc + img_sel_stg  + img_ext); 
        setImgInfoSTGFile(img_loc + img_info_stg + img_ext); 
    
        switch (display_type)
        {
            case "stg-default": 
                setImgSTGFile(   img_loc + img_stg     + img_sel + img_ext); 
                setSTGDisplay( <> <TeamShortTermGoalDefaultMessage /> </> ); 
                break;
            case "stg": 
                setImgSTGFile(   img_loc + img_stg     + img_sel + img_ext); 
                setSTGDisplay( <> <TeamShortTermGoal /> </> ); 
                break;
            case "add": 
                setImgAddSTGFile(img_loc + img_add_stg + img_sel + img_ext); 
                setSTGDisplay( <> <TeamShortTermGoalAddForm /> </> ); 
                break;
            case "sel": 
                setImgSelSTGFile(img_loc + img_sel_stg + img_sel + img_ext); 
                setSTGDisplay( <> <TeamShortTermGoalsList display_sel_stg={display_sel_stg} /> </> ); 
                break;
            case "info": 
                setImgInfoSTGFile(img_loc + img_info_stg + img_sel + img_ext); 
                setSTGDisplay( <> <TeamShortTermGoalsInformation /> </> ); 
                break;
        }
        
        setCurrentDisplayType(display_type);
    } 

    return (
        <>
            <div class="card mt-2">
                <div id="stg-card-header" class="card-header">
                    <div class="row">
                        <div id="stg-title" class="col text-start">
                            <a href="#"><img class="card-icon" src="./images/stg.svg" alt="goals" border="0"/></a>
                            <span className="card-sub-title">Short-Term Goals</span>
                        </div>
                        <div class="col-5 text-end">
                            <a href="#" ref={tooltipRef_stg}  data-bs-toggle="tooltip" data-bs-title="View Current Goal" data-bs-delay="750"><img class="card-icon"     src={img_stg_file}      alt="stg"  border="0" onClick={ () => change_display("stg") }/></a>
                            <a href="#" ref={tooltipRef_add}  data-bs-toggle="tooltip" data-bs-title="Add New Goal"      data-bs-delay="750"><img class="card-icon"     src={img_add_stg_file}  alt="add"  border="0" onClick={ () => change_display("add") }/></a>
                            <a href="#" ref={tooltipRef_sel}  data-bs-toggle="tooltip" data-bs-title="Select Goal"       data-bs-delay="750"><img class="card-icon"     src={img_sel_stg_file}  alt="sel"  border="0" onClick={ () => change_display("sel") }/></a>
                            <a href="#" ref={tooltipRef_info} data-bs-toggle="tooltip" data-bs-title="Goal Information"  data-bs-delay="750"><img class="card-icon-end" src={img_info_stg_file} alt="info" border="0" onClick={ () => change_display("info") }/></a>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="ms-2 me-auto">
                        {stg_display}
                    </div>
                </div>
            </div>
            <TeamAssignedActionItemList />
        </>
    );
}